import StatusDisplayer from "@components/StatusDisplayer";
import { IconButton, Stack, Typography } from "@mui/material";
import { FC } from "react";
import { createPortal } from "react-dom";
import { Rnd } from "react-rnd";
import CloseIcon from "@mui/icons-material/Close";
import useLocalStorage from "@/hooks/useLocalStorage";

interface StatusPopupProps {
  open: boolean;
  users: UserWithColor[];
  onClose: () => void;
}

const StatusPopup: FC<StatusPopupProps> = ({ open, users, onClose }) => {
  const [popupWidth, setPopupWidth] = useLocalStorage("statusPopupWidth", 1000);
  const [popupHeight, setPopupHeight] = useLocalStorage("statusPopupHeight", 320);
  const [popupX, setPopupX] = useLocalStorage("statusPopupX", 0);
  const [popupY, setPopupY] = useLocalStorage("statusPopupY", 0);

  return (
    open && (
      <>
        {createPortal(
          <Rnd
            default={{
              x: popupX,
              y: popupY,
              width: popupWidth,
              height: popupHeight,
            }}
            style={{
              backgroundColor: "white",
              minWidth: 1000,
              minHeight: 320,
              borderRadius: 5,
              boxShadow: "0px 0px 15px -2px rgba(0,0,0,0.6)",
            }}
            // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
            onResizeStop={(e, dir, elementRef, delta, position) => {
              setPopupHeight(popupHeight + delta.height);
              setPopupWidth(popupWidth + delta.width);
            }}
            onDragStop={(e, data) => {
              setPopupX(data.x);
              setPopupY(data.y);
            }}>
            <Stack justifyContent="space-between" direction="row" sx={{ padding: 2 }}>
              <Typography variant="h4">Statuts</Typography>
              <IconButton onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </Stack>
            <StatusDisplayer usersToShow={users} />
          </Rnd>,
          document.body
        )}
      </>
    )
  );
};

export default StatusPopup;
